export const mergeTagsContentStyle: string = '' +
  '.mce-offscreen-selection {position: absolute; top: -10000px; left: -10000px;} ' +
  '.pm-merge-tag {font-family: monospace, Courier, monospace;} ' +
  '.pm-merge-tag ' +
  '  > .pm-merge-tag-affix {padding: 0 2px;} ' +
  '.pm-merge-tag:hover {cursor: pointer; background-color: #7961db26} ' +
  '.pm-merge-tag[data-mce-selected] {background-color: #7961db26; outline: 1px solid #dce0e5;} ' +
  '.pm-merge-tag[data-mce-selected] ' +
  '  > .pm-merge-tag-affix {background-color: rgba(0, 108, 231, .1); color: #006ce7;} ';
